import HTTP from '@/utils/http';
import pageableFactory from '@/store/modules/mixins/pageable';
import crudableFactory from '@/store/modules/mixins/crudable';

const pageable = pageableFactory();
const crudable = crudableFactory();
const defaultState = () => ({
    ...pageable.state,
    ...crudable.state,
    pagingLimit: 1000, // Essentially unlimited
    group: null,
});

const groupsModule = {
    namespaced: true,
    state: defaultState(),
    mutations: {
        ...pageable.mutations,
        ...crudable.mutations,
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        SET_GROUP(state, group) {
            state.group = group;
        },
    },
    actions: {
        RESET_STATE({ commit }) {
            commit('RESET_STATE');
        },
        GET_GROUP_BY_ID({ commit }, groupId) {
            return HTTP({
                url: `groups/${groupId}`,
            }).then((response) => {
                commit('SET_GROUP', response.data.data);
            });
        },
        UPDATE(...args) {
            return crudable.actions.updatePartialApplication({
                uriRoot: 'groups',
                name: 'team',
                props: {
                    id: 'id',
                    name: 'name',
                    users: 'users',
                },
            }).apply(this, args);
        },
        CREATE: crudable.actions.createPartialApplication({
            uriRoot: 'groups',
            name: 'team',
            props: ['name', 'users'],
            isSingular: false,
        }),
        PAGINATE(...args) {
            return pageable.actions.paginatePartialApplication({
                url: 'groups',
                params: {},
            }).apply(this, args);
        },
        DELETE: crudable.actions.deletePartialApplication({ uriRoot: 'groups', name: 'team' }),
    },
    getters: {
        ...pageable.getters,
        group: state => state.group,
    },
};

export default groupsModule;

